var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeeding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.722,
    height: 34.188,
    viewBox: "0 0 20.722 34.188",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feeding_Stations",
    "data-name": "Feeding Stations",
    transform: "translate(0.824 0.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_16",
    "data-name": "Union 16",
    d: "M11.948,33.135H1.339L0,30.563H4.156v-2.52h1.6V26.6h-1.6V23.739h1.6V22.3h-1.6V19.327h1.6V17.887h-1.6V15.023h1.6v-1.44h-1.6V10.809H0L1.339,8.234H2.774L4.1,5.693H8.969V4.017a2.044,2.044,0,1,1,2.583-1.972H10.475a.968.968,0,1,0-.969.967h.539V5.693h4.929L16.3,8.234h1.436l1.339,2.571H14.917v2.777H13.361v1.44h1.556v2.864H13.361v1.439h1.556V22.3H13.361v1.44h1.556V26.6H13.361v1.44h1.556v2.52h4.156l-1.339,2.572ZM7.066,28.043h5.151V26.6H7.066Zm0-4.3h5.151V22.3H7.066Zm0-4.412h5.151V17.887H7.066Zm0-4.3h5.151v-1.44H7.066Z",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeeding);
export default __webpack_public_path__ + "static/media/feeding.3c23bd72f09c929907255cd3a6564bcc.svg";
export { ForwardRef as ReactComponent };